import { DocsStore } from "./stores/docs-store"
import type { IDocsStore } from "./interfaces"

export interface DocsNamespace {
  docsStore: IDocsStore
}

export class DocsNamespaceFactory {
  static create(): DocsNamespace {
    const docsStore = new DocsStore()
    
    return {
      docsStore,
    }
  }
}
